<template>
  <vonap-promised :promise="promise">
    <vonap-fullscreen-dialog
      :title="!isNew ? currentScenario.scenarioName : 'New Scenario'"
      :show-close-button="true"
      :show-save-button="!isDisabled"
      @save="formSubmit"
      @close="show = false"
    >
      <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="formSubmit">
        <v-container fluid grid-list-sm>
          <v-layout row wrap>
            <v-flex md3 xs12>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field
                    label="Scenario"
                    v-model="currentScenario.scenarioName"
                    required
                    :rules="[v => !!v || 'Scenario name is required']"
                    :disabled="isDisabled"
                  />
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12>
                  <vonap-form-label label="Dashboard Date">
                    <kendo-datepicker
                      name="DashboardDate"
                      style="width:100%"
                      :format="'yyyy-MM-dd'"
                      required="required"
                      :disabled="isDisabled"
                      :validation-message="'Dashboard Date is Required'"
                      v-model="currentScenario.dashboardDate"
                    ></kendo-datepicker>
                  </vonap-form-label>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field
                    label="To"
                    placeholder="Email address"
                    v-model="currentScenario.sendToEmail"
                    :disabled="isDisabled"
                  />
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field
                    label="Subject"
                    placeholder="Subject"
                    v-model="currentScenario.subject"
                    :disabled="isDisabled"
                  />
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12>
                  <vonap-form-label label="Body">
                    <textarea
                      name="body"
                      style="width:98%;"
                      rows="6"
                      v-model="currentScenario.body"
                      :disabled="isDisabled"
                    ></textarea>
                  </vonap-form-label>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex md9 xs12>
              <v-layout row wrap class="dashboardList">
                <v-flex md12>
                  <kendo-grid
                    :filterable="!isDisabled"
                    :sortable="!isDisabled"
                    :pageable="!isDisabled"
                    :persistSelection="true"
                    :data-source="dataSource"
                    v-on:databound="onGridDataBound"
                    ref="dashboardGrid"
                  >
                    <kendo-grid-column
                      :selectable="!isDisabled"
                      :filterable="true"
                      :attributes="{class: 'selectableCol'}"
                      :locked="true"
                      :width="50"
                    >
                    </kendo-grid-column>

                    <kendo-grid-column field="dashboardName" title="Dashboard" :width="450" />
                    <kendo-grid-column field="responsible" title="Responsible" :width="350" />
                  </kendo-grid>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </vonap-fullscreen-dialog>
  </vonap-promised>
</template>

<script>
import axios from 'axios'
import {mapGetters} from 'vuex'
import VonapFullscreenDialog from '@/components/VonapFullscreenDialog'
import VonapFormLabel from '@/components/VonapFormLabel'
import VonapPromised from '@/components/VonapPromised'
import security from '@/mixins/security'
import notification from '@/helpers/notification'

export default {
  name: 'DashboardScenrioForm',
  props: {
    value: Boolean,
    dashboardScenarioId: Number,
  },
  mixins: [security],
  data() {
    return {
      isNew: this.dashboardScenarioId == -1,
      saving: false,
      errored: false,
      valid: false,
      products: [],
      currentScenario: {},
      availableDashboards: [],
      selectedDashboards: [],
      selectedDashboardsId: [],
    }
  },
  methods: {
    saveSelection() {
      const grid = this.$refs.dashboardGrid.kendoWidget()
      const selectedIds = grid.selectedKeyNames().map(id => +id)
      if (selectedIds.length == 0) {
        notification('Please select one', 'error')
      } else {
        this.selectedDashboardsId = selectedIds
      }
    },
    onGridDataBound(e) {
      var gridData = e.sender.dataSource.view()
      var grid = this.$refs.dashboardGrid.kendoWidget()
      let vm = this
      gridData.forEach(dataItem => {
        var row = grid.table.find("tr[data-uid='" + dataItem.uid + "']")
        if (vm.selectedDashboards.includes(dataItem.dashboardId)) {
          grid.select(row)
        }
      })
    },
    async formSubmit() {
      this.saveSelection()
      if (!this.$refs.form.validate() || this.selectedDashboardsId.length == 0) return
      this.selectedDashboards = this.selectedDashboardsId

      this.saving = true
      this.currentScenario.dashBoardList = this.selectedDashboards
      if (this.dashboardScenarioId != -1) {
        await axios
          .put('/api/config/dashboardScenario', {
            item: this.currentScenario,
            clientId: +this.clientId,
          })
          .catch(() => (this.errored = true))
        this.saving = false
      } else {
        const {data} = await axios
          .post('/api/config/dashboardScenario', {
            item: this.currentScenario,
            clientId: +this.clientId,
          })
          .catch(() => (this.errored = true))
        const newDaschboardScenario = data.data[0]
        this.isNew = false
        this.currentScenario.dashboardScenarioId = newDaschboardScenario.dashboardScenarioId
        this.dashboardScenarioId = newDaschboardScenario.dashboardScenarioId
        this.saving = false
      }

      this.$emit('save')
    },
    async getData() {
      //const {data: availableDashboards} = await axios.get(
      //  '/api/config/dashboardScenario/getClientDahboards?clientId=' + this.clientId,
      //  {},
      //)
      //this.availableDashboards = availableDashboards

      const {data: currentScenario} = await axios.get('/api/config/dashboardScenario/getScenario', {
        params: {dashboardScenarioId: this.dashboardScenarioId, clientId: this.clientId},
      })
      this.currentScenario = currentScenario
      if (this.dashboardScenarioId != -1) {
        this.selectedDashboards = currentScenario.dashboardList
        //this.selectedDashboards = currentScenario.dashboardList.map(item => item.dashboardId)
      }
    },
  },
  computed: {
    isDisabled() {
      return !this.isNew
    },
    show: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    promise() {
      return this.getData()
    },
    ...mapGetters({clientId: 'authentication/selectedClientId'}),
    ...mapGetters({currentRole: 'authentication/currentRole'}),
    dataSource() {
      return new kendo.data.DataSource({
        type: 'aspnetmvc-ajax',
        serverPaging: true,
        serverFiltering: true,
        serverSorting: true,
        pageSize: 0,
        transport: {
          read: {
            type: 'GET',
            url: '/api/config/dashboardScenario/getDashboadDataSource',
            data: {
              clientId: this.clientId,
            },
            dataType: 'json',
          },
        },
        schema: {
          errors: 'errors',
          total: 'total',
          data: 'data',
          model: {
            id: 'dashboardId',
            fields: {
              dashboardId: {type: 'number'},
              dashboardName: {type: 'string'},
              responsible: {type: 'string'},
            },
          },
        },
        error: function() {
          //let grid = $('#contractGrid').data('kendoGrid')
          //grid.one('dataBinding', e => {
          //  e.preventDefault()
          //})
        },
      })
    },
  },
  components: {
    VonapFullscreenDialog,
    VonapFormLabel,
    VonapPromised,
  },
}
</script>
<style scoped>
textarea {
  display: flex;
  vertical-align: bottom;
  border: 1px;
  border-style: dotted;
}
</style>

<style>
.configSwitch > div > div > label {
  font-size: 10px !important;
}
.dashboardList {
  font-size: 10px !important;
}
</style>
